import { render, staticRenderFns } from "./HowItWorksPopoverContents.vue?vue&type=template&id=5887f268&"
import script from "./HowItWorksPopoverContents.vue?vue&type=script&lang=js&"
export * from "./HowItWorksPopoverContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports